'use strict';

var _ = require('lodash');
var ConfigurationFoCityAptsController = function ConfigurationFoCityAptsController($scope, dataRetrieverService, configurationFoCityAptsService, dataRetrieverConstantsService) {
  dataRetrieverService.getDataRetriever('SYSTEM_STATUS_SCREEN', dataRetrieverConstantsService.SYSTEM_STATUS_CONFIGURATION_FO_CITYAPTS_MODE).setCustomSearchCriteriaRules([]);
  $scope.makeExportToCsv = function (data) {
    configurationFoCityAptsService.exportToCsv(data);
  };
  $scope.customRemove = function (rowsToBeRemovedFromServer, gridData, rowIndicesToBeRemoved) {
    configurationFoCityAptsService.remove(rowsToBeRemovedFromServer, gridData, rowIndicesToBeRemoved);
  };
  $scope.customSave = function (editedRows, gridData) {
    return configurationFoCityAptsService.save(editedRows, gridData);
  };
  $scope.customSaveValidation = function (editedRows, gridData) {
    return configurationFoCityAptsService.validate(editedRows, gridData);
  };
};
ConfigurationFoCityAptsController.$inject = ['$scope', 'DataRetrieverService', 'ConfigurationFoCityAptsService', 'DataRetrieverConstantsService'];
module.exports = ConfigurationFoCityAptsController;